<template>
  <div class="H5_product">
    <van-nav-bar
      class="jinkf"
      :title="$t('h5.DSX_index_detail')"
      :left-text="$t('h5.DSX_index_back')"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-swipe style="margin-top:30px">
      <van-swipe-item v-for="(image, index) in productData.images" :key="index">
        <img style="width:100%" v-lazy="image.image" />
      </van-swipe-item>
    </van-swipe>

    <div class="desc_box">
      <div>
        <span class="knv">{{$t('h5.DSX_price')}}</span>
        <span class="ilkmn">
          RMB
          <span
            v-if="storeItem.price.length > 1 && storeItem.price[0]"
          >{{(storeItem.price[0]).toFixed(2)}}~{{(storeItem.price[1]).toFixed(2)}}</span>
          <span v-else>{{(storeItem.price[0]).toFixed(2)}}</span>
        </span>
      </div>
      <div class="name">{{productData.name}}</div>
    </div>

    <div class="desc_box">
      <div class="invkf">
        <div class="kvnkf">Specifications:</div>
        <div class="variationSku" v-for="(item,index) in productData.variations" :key="index">
          <span>{{item.variationSku}}</span>
          <span style="margin-left:18px">inventory:{{item.stock}}</span>
        </div>
      </div>
      <!-- <div class="onkv" @click="inlnv()">...共{{productData.variations.length}}{{$t('other.a2504')}},查看更多</div> -->
    </div>

    <div class="jgknv">
      <div class="pppmiuj">Information Description</div>
      <el-input type="textarea" autosize :placeholder="$t('other.a319')" v-model="productData.description"></el-input>
      <div class="ignklvk">view all</div>
    </div>

    <div class="jgknv">
      <div class="pppmiuj">Details of Goods</div>
      <div v-for="(item, index) in productData.images" :key="index">
        <img style="width:100%" :src="item.image" />
      </div>
    </div>
    <van-submit-bar
      style="width:50%"
      round
      :button-text="$t('h5.DSX_index_Quote')"
      @submit="show=true"
    />
    <van-submit-bar
    class="rightBtn"
     
      :button-text="$t('h5.DSX_index_distribute')"
      @submit="onSubmit"
    />
    <!-- 自定义图标 -->
    <van-popup
      v-model="show"
      closeable
      close-icon="close"
      position="bottom"
      @close="claerInput"
      :style="{ height: '50%' }"
    >
    <div class="variations descText">Please fill in the form if you are interested in our products and we will contact you soon</div>
      <div class="variations">
        <div
          :class="{'active':active != index}"
          v-for="(item,index) in productData.variations"
          :key="index"
        >
          <van-tag
            class="tabs"
            plain
            @click="active =index,cusCode=item.cusCode,price=item.price"
            type="primary"
          >{{item.variationSku}}</van-tag>
        </div>
      </div>
      <div class="purchaseQty">
        <span class="desc">Quantity</span>
        <van-stepper v-model="quantity" />
      </div>
      <div class="purchaseQty">
        <span class="desc">Whatsapp</span>
        <van-field v-model="Whatsapp" input-align="right" placeholder="Whatsapp" />
      </div>
      <div class="btn">
        <!-- <van-button type="danger">主要按钮</van-button> -->
        <van-button type="primary" @click="createOrder" block>Contact me later</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import api from "../../../api/api";
import newOrdersApi from "../../../api/moudles/newOrders";
import distributionApi from "../../../api/moudles/distribution";
import userStoreItems from "../../../api/moudles/userStoreItems";
import utils from "../../../utils/utils";

export default {
  data() {
    return {
      quantity: 100,
      Whatsapp: "",
      cusCode: "",
      price: null,
      active: 0,
      images: [
        "https://img01.yzcdn.cn/vant/apple-1.jpg",
        "https://img01.yzcdn.cn/vant/apple-2.jpg"
      ],
      productData: {
        images: [],
        variations: [
          {
            variationSku: null
          }
        ],
        variationsCopy: [
          {
            variationSku: null
          }
        ]
      },
      show: false,
      isLoading: false,
      storeItem: {
        storeItems: [],
        price: []
      },
      userId: null
    };
  },
  created() {
    this.userId = JSON.parse(localStorage.getItem("userInfo"))
      ? JSON.parse(localStorage.getItem("userInfo")).userId
      : null;
    this.getData();
  },
  methods: {
    claerInput(){
        this.active=0
        this.quantity=1
        this.whatsApp=''
        this.cusCode=this.productData.variations[0].cusCode
    },
    createOrder() {
      if (!this.userId) {
        this.$dialog.alert({
          message: "user is not logged in, go to login",
          confirmButtonText:'comfirm'
        }).then(res => {
          
          this.$router.push({
                path: "/mh5/login",
                query: {
                  invitationCode: this.$route.query.invitationCode,
                  from:'detail',
                  groupId: this.$route.query.groupId,
                  productId : this.$route.query.productId
                }
              });
        });


        return;
      }
      distributionApi
        .createInquiryOrder({
          items: [
            {
              amount: this.quantity,
              cusCode: this.cusCode,
              price: this.price
            }
          ],
          whatsApp: this.whatsApp,
          userId: this.userId,
          sellerUserId: this.productData.userId
        })
        .then(res => {
          if (res.code === 200) {
            this.$dialog.alert({
              message: 'We will contact you later!',
              title: "Successful inquiry!",
              confirmButtonText:'comfirm'
            });
          } else {
            this.$dialog.alert({
              message: res.msg,
              title: "inquiry fail!",
              confirmButtonText:'comfirm'
            });
          }
        });
    },
    inlnv() {
      this.productData.variationsCopy = this.productData.variations;
      console.log(this.productData);
    },
    getRecommond() {
      let str =
        "catid=" +
        this.storeItem.categoryData.catId +
        "&itemid=" +
        this.storeItem.categoryData.itemId +
        "&shopid=" +
        this.storeItem.categoryData.shopId;

      let url = utils.getSimilaryData(
        this.storeItem.country.toLowerCase(),
        str
      );
      console.log("str", str);
      console.log("str", url);
      newOrdersApi
        .proxyHttps({
          type: 0,
          url: url,
          headerMap: null
        })
        .then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
          }
        });
    },

    onSubmit() {
      console.log(this.storeItem);
      let id = this.storeItem.storeItems[0].userId;
      if (id == this.userId) {
        this.$dialog.alert({
          message: this.$t('other.a1703'),
          confirmButtonText:'comfirm'
        });
        return;
      }

      this.storeItem.userId = this.userId;

      api.copyStoreItem(this.storeItem).then(res => {
        if (res.code === 200) {
          this.$dialog.alert({
            message: this.$t("h5.DSX_index_tips"),
            title: "Dropshipping success!",
            confirmButtonText:'comfirm'
          });

          if(res.data.storeItems){
              res.data.storeItems.forEach(p => {
                p.synchrony=true
                this.updataSync(p)
              })
            }
        } else {
          this.$dialog
            .alert({
              message: res.msg,
              title: "Dropshipping fail!",
              confirmButtonText:'comfirm'
            })
            .then(() => {
              //点击确认按钮后的调用
              this.$router.push({
                path: "/mh5/login",
                query: {
                  invitationCode: this.$route.query.invitationCode
                }
              });
            })
            .catch(() => {
              //点击取消按钮后的调用
              console.log("点击了取消按钮噢");
            });
        }
      });
    },
    updataSync(ttp){
      userStoreItems
        .sellerUpdateSynchrony(ttp)
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        }else{
        console.log(res.msg)
        }
        })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('other.a1228'));
        this.isLoading = false;
      }, 1000);
    },

    onClickLeft() {
      if (this.$route.query.country) {
        this.$router.push({
          path: "/mh5/pageOne",
          query: {
            country: this.$route.query.country
          }
        });
      } else {
        this.$router.push({
          path: "/mh5/index",
          query: {
            invitationCode: this.$route.query.invitationCode
          }
        });
      }
    },
    onClickRight() {},
    getData() {
      let id = this.$route.query.groupId;
      let productId = this.$route.query.productId;

      if (id) {
        api.getStoreItemByGroupId({ groupId: id }).then(res => {
          if (res.code === 200) {
            this.storeItem = res.data;
            this.storeItem.amount = 0;
            this.storeItem.price = [];
            this.storeItem.storeItems.forEach(i => {
              this.storeItem.amount += i.stock;
              if (i.price) {
                this.storeItem.price.push(i.price);
              }
            });
            console.log("id", this.storeItem);
            this.storeItem.price = [...new Set(this.storeItem.price)];
            if (this.storeItem.price.length > 1) {
              this.storeItem.price.sort((a, b) => {
                return a - b;
              });
            }
            console.log("id", res.data);
            this.getRecommond();
          } else {
            this.$message.warning(res.msg);
          }
        });
      }

      if (productId) {
        api.getProductByproductId({ productId: productId }).then(res => {
          if (res.code === 200) {
            console.log("productId", res.data);
            this.productData = res.data;
            this.cusCode=this.productData.variations[0].cusCode
            this.price=this.productData.variations[0].price
            this.productData.variationsCopy = res.data.variations.slice(0, 18);
          } else {
            this.$message.warning(res.msg);
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.H5_product {
  width: 100%;
  min-height: 100vh;
  background-color: #eee;
  // margin-bottom: 5rem;

  /deep/.van-submit-bar__button {
    width: 100%;
  }

  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;

    /deep/ .van-button--primary{
      background-color: #409eff;
    }
  }

  .rightBtn{
    width:50%;
    right: 0;
    left:unset;

    /deep/ .van-submit-bar__button--danger{
      background: #409eff;
    }
  }
  .descText{
    text-align: center;
    color: #409eff;
    font-size: 16px;
    margin-top: 0!important;
  }

  .variations {
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 1rem 1rem;

    .tabs {
      margin-right: 1rem;
    }

    .active {
      /deep/ .van-tag--primary {
        color: #999999 !important;
      }
    }
  }

  .purchaseQty {
    margin-top: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem 1rem;

    .desc {
      color: #999999;
      font-size: 16px;
    }
  }

  .jinkf {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
  }
  .my-swipe {
    width: 100%;

    .van-swipe-item {
      color: #fff;
      font-size: 30px;
      line-height: 150px;
      text-align: center;
      background-color: #39a9ed;
    }
  }

  .van-nav-bar {
    background-color: #409eff;
  }

  .jgknv {
    background-color: #fff;
    margin-bottom: 20px;

    .pppmiuj {
      padding: 10px 15px;
      font-size: 15px;
    }

    .ignklvk {
      width: 100%;
      text-align: center;
      padding: 10px 0;
      font-size: 15px;
    }
  }

  .title {
    font-size: 20px;
    padding: 0 15px;
    border-bottom: 0.04rem solid #eee;
  }

  .onkv {
    font-size: 14px;
    text-align: right;
    color: red;
  }

  .invkf {
    // display: flex;
    // align-items: center;
    // box-sizing: border-box;
    padding: 20px 5px !important;

    .kvnkf {
      width: 2rem;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 8px;
    }

    .variationSku {
      font-size: 14px;
      padding: 2px 0;
    }
  }

  .desc_box {
    background: #fff;
    border-radius: 5px;
    margin: 20px 5px;
    box-sizing: border-box;
    padding: 10px;

    .knv {
      font-size: 10px;
      color: red;
      box-sizing: border-box;
      padding: 3px;
      border: 1px solid red;
      border-radius: 3px;
      font-weight: 500;
    }

    .ilkmn {
      font-size: 25px;
      color: red;
      margin-left: 10px;
    }

    .name {
      font-size: 16px;
      padding: 10px 0;
      font-weight: bold;
    }
  }

  .sku_box {
    background: #fff;
    border-radius: 5px;
    margin: 5px;
    box-sizing: border-box;
    padding: 5px;
  }

  /deep/ .van-nav-bar__text {
    color: #fff !important;
    font-size: 18px;
  }

  /deep/ .van-icon {
    color: #fff;
  }

  /deep/ .van-nav-bar__title {
    color: #fff;
  }

  /deep/ .van-submit-bar {
    border-top: 0.1rem solid #eee;
    background-color: #eee;
  }

  .bottom {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
</style>